module.exports = __webpack_public_path__ + "img/car1.78f7a7dd.png";